<div class="cdk-overlay-backdrop cdk-overlay-dark-backdrop app-loading" [class.cdk-overlay-backdrop-showing]="spinner() !== false">
  <div class="spinner-container" [class.spinner-message]="spinnerHasMessage(spinner())">
    @if (spinner(); as spinner) {
      @if (spinnerHasMessage(spinner)) {
        <img src="assets/images/spinner-image.svg" class="img-fluid" />
        <div class="title">
          {{ 'bkwa.card.spinner.title' | translate }}
        </div>
        @for (spinnerParagraph of spinner; track spinnerParagraph) {
          <div class="paragraph">
            {{ spinnerParagraph | translate }}
          </div>
        }
      }
    }
    <mat-progress-spinner mode="indeterminate" diameter="64" />
  </div>
</div>
<mat-sidenav-container autosize class="transition-loading" [class.loaded]="loaded">
  <mat-sidenav #sidenav>
    <mat-nav-list>
      @for (item of navigation; track item) {
        <mat-list-item class="menu-item" [class.active]="isActive(item)">
          <a [routerLink]="['/' + item.link]" (click)="sidenav.close()">
            <mat-icon>{{ item.icon }}</mat-icon>
            {{ item.label | translate }}
          </a>
        </mat-list-item>
      }
      @if (fullScreenEnabled) {
        @if (!isFullScreen()) {
          <mat-list-item class="menu-item">
            <a (click)="enterFullScreen(); sidenav.close()">
              <mat-icon>fullscreen</mat-icon>
              {{ 'bkwa.common.fullscreen' | translate }}
            </a>
          </mat-list-item>
        }
        @if (isFullScreen()) {
          <mat-list-item class="menu-item">
            <a (click)="exitFullScreen(); sidenav.close()">
              <mat-icon>fullscreen_exit</mat-icon>
              {{ 'bkwa.common.normalscreen' | translate }}
            </a>
          </mat-list-item>
        }
      }
    </mat-nav-list>
  </mat-sidenav>
  <header>
    <mat-toolbar>
      <div class="container-fluid">
        <div class="menu left">
          @if (isAuthenticated) {
            <button mat-icon-button class="d-md-none" (click)="sidenav.toggle()" [matTooltip]="'bkwa.common.menu' | translate">
              <mat-icon>menu</mat-icon>
            </button>
          }
          <h1>
            <a routerLink="/">
              @if (theme != null && theme.getLogo(); as logo) {
                <img [src]="logo" alt="Bookker" @revealAnimation />
              }
              <span class="visually-hidden">{{ title }}</span>
            </a>
          </h1>
        </div>
        <div class="menu right">
          <button mat-icon-button type="button" [matMenuTriggerFor]="optionsMenu" [matTooltip]="'bkwa.common.options' | translate">
            <mat-icon>more_vert</mat-icon>
          </button>
          <mat-menu #optionsMenu="matMenu">
            @if (isAuthenticated) {
              <a mat-menu-item (click)="logout()">
                {{ 'bkwa.menu.logout' | translate }}
              </a>
            }
            <a mat-menu-item [href]="getHelpCenterLink()" target="_blank" rel="noopener">
              {{ 'bkwa.menu.helpCenter' | translate }}
            </a>
            @if (isAuthenticated) {
              <a mat-menu-item (click)="openPrivacyPolicy()">
                {{ 'bkwa.privacyPolicy.title' | translate }}
              </a>
            }
            @if (version) {
              <a mat-menu-item (click)="copyVersion()" class="text-muted">
                Webapp v{{ version }}
                @if (!isProduction) {
                  <small>
                    (
                    @if (gitVersion.hash) {
                      <span class="font-monospace" [title]="gitVersion.raw">{{ gitVersion.hash | slice: 0 : 5 }}…</span>
                    }
                    @if (gitVersion.dirty) {
                      *
                    }
                    )
                  </small>
                }
              </a>
            }
          </mat-menu>
        </div>
      </div>
    </mat-toolbar>
  </header>
  <div class="content-wrapper">
    @if (isAuthenticated && currentMenu !== 'login' && currentMenu !== 'logout' && currentMenu !== 'privacy-policy') {
      <div class="aside-wrapper" @revealAnimation>
        <aside>
          <mat-nav-list class="d-none d-md-block">
            @for (item of navigation; track item) {
              <mat-list-item
                class="menu-item aside-menu-item"
                [class.active]="isActive(item)"
                [attr.data-testid]="'sidebar-' + item.link + '-button'"
              >
                <a [routerLink]="['/' + item.link]" class="aside-menu-item-link">
                  <mat-icon>{{ item.icon }}</mat-icon>
                  {{ item.label | translate }}
                  @if (isActive(item)) {
                    <span class="visually-hidden">({{ 'bkwa.menu.current' | translate }})</span>
                  }
                </a>
              </mat-list-item>
            }
          </mat-nav-list>
        </aside>
      </div>
    }
    <main [@routerAnimation]="prepareRoute(outlet)">
      <div class="view-container">
        <router-outlet #outlet="outlet"></router-outlet>
      </div>
    </main>
    @if (showCookies) {
      <div class="cookies">
        <h3>{{ 'bkwa.cookies.title' | translate }}</h3>
        <p>
          {{ 'bkwa.cookies.notice' | translate }}
        </p>
        <div class="d-flex justify-content-end">
          <button mat-flat-button color="primary" (click)="acceptCookies()" data-testid="cookie-consent-button">
            {{ 'bkwa.cookies.accept' | translate }}
          </button>
        </div>
      </div>
    }
  </div>
</mat-sidenav-container>
